import React from 'react'
import Dropzone from 'react-dropzone'
import axios from 'axios'
import FormData from 'form-data'

class Uploader extends React.Component {
	onImageDrop(files){
		this.handleImageUpload(files[0])
	}

	handleImageUpload(file){
		let data = new FormData()
		data.append('upfile', file)

		axios.post('https://dhsetheatre-api.madebypeppernet.com/image_upload.php', data)
		.then( ( response ) => {
			if(response && response.data){
				// Verify the response isn't an error.
				if(response.data.indexOf('Error: ') === -1){
					// If the user passed in a handler function, call it.
					this.props.uploadComplete(response.data)
				}
			}
		})
	}

	render() {
		return (
			<Dropzone
				multiple={false}
				accept="image/*"
				onDrop={this.onImageDrop.bind(this)}
				className={this.props.className}>
				<p>{this.props.label || 'Drop an image or click to select a file to upload.'}</p>
			</Dropzone>
		)
	}
}

export default Uploader



// WEBPACK FOOTER //
// ./src/components/uploader.js